import { render, staticRenderFns } from "./FormOffsetAmount.vue?vue&type=template&id=c7a5a1c8&scoped=true&"
import script from "./FormOffsetAmount.vue?vue&type=script&lang=js&"
export * from "./FormOffsetAmount.vue?vue&type=script&lang=js&"
import style0 from "./FormOffsetAmount.vue?vue&type=style&index=0&id=c7a5a1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a5a1c8",
  null
  
)

export default component.exports